import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class AdjustmentsModule {
    constructor() {
        this.adjustments = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(adjustments) {
        this.adjustments = adjustments;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.adjustments;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.adjustments.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async add(adjustments) {
        try {
            await service.adjustments.add(adjustments);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(adjustments) {
        try {
            await service.adjustments.edit(adjustments);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async delete(adjustmentsId) {
        try {
            await service.adjustments.delete(adjustmentsId);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], AdjustmentsModule.prototype, "adjustments", void 0);
__decorate([
    State()
], AdjustmentsModule.prototype, "count", void 0);
__decorate([
    State()
], AdjustmentsModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], AdjustmentsModule.prototype, "setItems", null);
__decorate([
    Mutation()
], AdjustmentsModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], AdjustmentsModule.prototype, "setError", null);
__decorate([
    Getter()
], AdjustmentsModule.prototype, "list", null);
__decorate([
    Getter()
], AdjustmentsModule.prototype, "total", null);
__decorate([
    Getter()
], AdjustmentsModule.prototype, "errorList", null);
__decorate([
    Action()
], AdjustmentsModule.prototype, "get", null);
__decorate([
    Action()
], AdjustmentsModule.prototype, "add", null);
__decorate([
    Action()
], AdjustmentsModule.prototype, "edit", null);
__decorate([
    Action()
], AdjustmentsModule.prototype, "delete", null);
